import React from "react";

export const NotFound: React.FC = () => {
  return (
    <div>
      <h1>Page not found</h1>
    </div>
  );
};
